import React, { useEffect, useState } from "react";
import {
  AddButton,
  CustomConfirmModal,
  PaginationDropdown,
  ThinDropdownWithSearch,
  ThinTextField,
} from "../common/GeneralComponent";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
} from "@mui/material";
import {
  ChevronsRightIcon,
  Edit,
  Trash,
  Minus,
  Plus,
  Download,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import { Pagination } from "@mui/material";
import { fetchData } from "../../utils/functions";
import "font-awesome/css/font-awesome.min.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";
import GeneralFooter from "../common/GeneralFooter";
import PermissionButton from "../common/PermissionButton";

const formatDateForAPI = (dateString) => {
  if (!dateString) return null;

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const formatDateForDisplay = (dateString) => {
  if (!dateString) return "N/A";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "N/A";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

const HealthFacilityAssessmentsListing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user: loggedInUser } = useSelector((state) => state.auth);
  const permissions = loggedInUser?.user_permissions || [];
  const [healthFacilitiesData, setHealthFacilitiesData] = useState([]);
  const [search, setSearch] = useState("");
  const [isModalVisible, setModalVisible] = useState(false);
  const [selectedUuid, setSelectedUuid] = useState(null);
  const [isApproveModalVisible, setApproveModalVisible] = useState(false);
  const [isRejectModalVisible, setRejectModalVisible] = useState(false);
  const [isRemarksModalVisible, setRemarksModalVisible] = useState(false);
  const [isViewRemarksModalVisible, setViewRemarksModalVisible] =
    useState(false);
  const [remarks, setRemarks] = useState("");
  const [remarksError, setRemarksError] = useState("");
  const [selectedApproveId, setSelectedApproveId] = useState(null);
  const [selectedRejectId, setSelectedRejectId] = useState(null);
  const [
    selectedHealthFacilityForRemarks,
    setSelectedHealthFacilityForRemarks,
  ] = useState(null);
  const [filterResetKey, setFilterResetKey] = useState(0);
  const [isFiltersVisible, setIsFiltersVisible] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [tehsils, setTehsils] = useState([]);
  const [ucs, setUcs] = useState([]);
  const [dehs, setDehs] = useState([]);
  const [villages, setVillages] = useState([]);

  const [tempDistrict, setTempDistrict] = useState(null);
  const [tempTehsil, setTempTehsil] = useState(null);
  const [tempUc, setTempUc] = useState(null);
  const [tempDeh, setTempDeh] = useState(null);
  const [tempVillage, setTempVillage] = useState(null);

  const [tempDateField, setTempDateField] = useState("");
  const [tempCondition, setTempCondition] = useState("");
  const [tempDateValue, setTempDateValue] = useState("");
  const [tempStartDate, setTempStartDate] = useState("");
  const [tempEndDate, setTempEndDate] = useState("");

  const [tempDqaStatus, setTempDqaStatus] = useState("");
  const [selectedDqaStatus, setSelectedDqaStatus] = useState("");

  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedTehsil, setSelectedTehsil] = useState(null);
  const [selectedUc, setSelectedUc] = useState(null);
  const [selectedDeh, setSelectedDeh] = useState(null);
  const [selectedVillages, setSelectedVillages] = useState(null);

  const [selectedDateField, setSelectedDateField] = useState(null);
  const [selectedCondition, setSelectedCondition] = useState(null);
  const [selectedDateValue, setSelectedDateValue] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);

  const [isExporting, setIsExporting] = useState(false);

  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 10,
    total_records: 0,
    total_pages: 0,
  });
  // DQA Status Options
  const dqaStatusOptions = [
    // { value: "", label: "All" },
    { value: "0", label: "Pending" },
    { value: "1", label: "Approved" },
    { value: "2", label: "Rejected" },
  ];

  const getLatestRemarks = (healthFacility) => {
    if (healthFacility.remarks && healthFacility.remarks.trim() !== "") {
      return healthFacility.remarks;
    }
    if (healthFacility.auditLogs && healthFacility.auditLogs.length > 0) {
      try {
        const latestAudit = healthFacility.auditLogs[0];
        const newValue = JSON.parse(latestAudit.newvalue);
        return newValue.remarks || "No remarks";
      } catch (error) {
        console.warn("Failed to parse audit log:", error);
        return "No remarks";
      }
    }
    return "No remarks";
  };

  const getRemarksHistory = (healthFacility) => {
    const history = [];
    if (healthFacility.remarks && healthFacility.remarks.trim() !== "") {
      history.push({
        action: "REJECT",
        date:
          healthFacility.verified_from_dqa_datetime ||
          healthFacility.created_at ||
          new Date().toISOString(),
        to: healthFacility.remarks,
        userName: "Super Admin", 
      });
    }
    if (healthFacility.auditLogs && healthFacility.auditLogs.length > 0) {
      healthFacility.auditLogs.forEach((log) => {
        try {
          const newValue = JSON.parse(log.newvalue);
          const oldValue = log.oldvalue ? JSON.parse(log.oldvalue) : null;
          if (newValue.remarks && newValue.remarks.trim() !== "") {
            history.push({
              action: log.action || "REJECT",
              date: log.createdAt,
              from: oldValue?.remarks || "None",
              to: newValue.remarks,
              userId: log.userId,
              userName: log.user?.name || "Super Admin", 
            });
          }
        } catch (error) {
          console.warn("Failed to parse audit log:", error);
        }
      });
    }
    return history.sort((a, b) => new Date(b.date) - new Date(a.date));
  };
  const showRemarksDialog = (healthFacility) => {

    setSelectedHealthFacilityForRemarks(healthFacility);
    setViewRemarksModalVisible(true);
  };
  const closeRemarksDialog = () => {
    setViewRemarksModalVisible(false);
    setSelectedHealthFacilityForRemarks(null);
  };

  const validateRemarks = (remarksText) => {
    if (!remarksText.trim()) {
      return "Remarks are required";
    }
    if (remarksText.trim().length < 10) {
      return "Remarks must be at least 10 characters long";
    }
    if (remarksText.trim().length > 255) {
      return "Remarks cannot exceed 255 characters";
    }
    return "";
  };

  const handleRemarksChange = (e) => {
    const newRemarks = e.target.value;
    setRemarks(newRemarks);
    if (remarksError) {
      const error = validateRemarks(newRemarks);
      setRemarksError(error);
    }
  };

  const hasFiltersApplied =
    selectedDistrict ||
    selectedTehsil ||
    selectedUc ||
    selectedDeh ||
    selectedVillages ||
    selectedDateField ||
    selectedCondition ||
    selectedDqaStatus;
  const hasDataToExport = healthFacilitiesData.length > 0;

  const dateFieldsOptions = [
    { value: "date_of_data_collection", label: "Date of Data Collection" },
  ];

  const conditions = [
    { value: "lt", label: "Less Than" },
    { value: "gt", label: "Greater Than" },
    { value: "equals", label: "Equal To" },
    { value: "between", label: "Between" },
  ];

  const toggleFilters = () => {
    setIsFiltersVisible((prev) => !prev);
  };

  const handleDistrictChange = (selected) => {
    setTempDistrict(selected);
    setTempTehsil(null);
    setTempUc(null);
    setTempDeh(null);
    setTempVillage(null);
    setTehsils([]);
    setUcs([]);
    setDehs([]);
    setVillages([]);
  };

  const handleTehsilChange = (selected) => {
    setTempTehsil(selected);
    setTempUc(null);
    setTempDeh(null);
    setTempVillage(null);
    setUcs([]);
    setDehs([]);
    setVillages([]);
  };

  const handleUcChange = (selected) => {
    setTempUc(selected);
    setTempDeh(null);
    setTempVillage(null);
    setDehs([]);
    setVillages([]);
  };

  const handleDehChange = (selected) => {
    setTempDeh(selected);
    setTempVillage(null);
    setVillages([]);
  };

  const handleVillageChange = (selected) => {
    setTempVillage(selected);
  };

  const handleDqaStatusChange = (selected) => {
    setTempDqaStatus(selected);
  };

  const handleFilterChange = (key, value) => {
    switch (key) {
      case "dateField":
        setTempDateField(value);
        if (value === "") {
          setTempCondition("");
          setTempDateValue("");
          setTempStartDate("");
          setTempEndDate("");
        }
        break;
      case "condition":
        setTempCondition(value);
        if (value !== "between") {
          setTempStartDate("");
          setTempEndDate("");
        } else {
          setTempDateValue("");
        }
        break;
      default:
        break;
    }
  };

  const handleApplyFilters = () => {
    if (tempCondition && !tempDateField) {
      toast.error("Please select a date field when using a condition");
      return;
    }
    if (tempCondition === "between") {
      if (!tempStartDate || !tempEndDate) {
        toast.error(
          "Please provide both start and end dates for 'between' condition"
        );
        return;
      }
      const startDate = new Date(tempStartDate);
      const endDate = new Date(tempEndDate);

      if (startDate > endDate) {
        toast.error("Start date must be before end date");
        return;
      }
    }
    if (tempCondition && tempCondition !== "between" && !tempDateValue) {
      toast.error("Please provide a date value for the selected condition");
      return;
    }

    setSelectedDistrict(tempDistrict);
    setSelectedTehsil(tempTehsil);
    setSelectedUc(tempUc);
    setSelectedDeh(tempDeh);
    setSelectedVillages(tempVillage);
    setSelectedDqaStatus(tempDqaStatus);
    setPagination((prev) => ({ ...prev, current_page: 1 }));

    setSelectedDateField(tempDateField);
    setSelectedCondition(tempCondition);

    if (tempCondition === "between") {
      setSelectedStartDate(formatDateForAPI(tempStartDate));
      setSelectedEndDate(formatDateForAPI(tempEndDate));
      setSelectedDateValue(null);
    } else if (tempCondition) {
      setSelectedDateValue(formatDateForAPI(tempDateValue));
      setSelectedStartDate(null);
      setSelectedEndDate(null);
    } else {
      setSelectedDateValue(null);
      setSelectedStartDate(null);
      setSelectedEndDate(null);
    }
  };

  const handleClearFilters = () => {
    setTempDistrict(null);
    setTempTehsil(null);
    setTempUc(null);
    setTempDeh(null);
    setTempVillage(null);
    setTempDqaStatus("");

    setSelectedDistrict(null);
    setSelectedTehsil(null);
    setSelectedUc(null);
    setSelectedDeh(null);
    setSelectedVillages(null);
    setSelectedDqaStatus("");

    setTehsils([]);
    setUcs([]);
    setDehs([]);
    setVillages([]);

    setTempDateField("");
    setTempCondition("");
    setTempDateValue("");
    setTempStartDate("");
    setTempEndDate("");

    setSelectedDateField(null);
    setSelectedCondition(null);
    setSelectedDateValue(null);
    setSelectedStartDate(null);
    setSelectedEndDate(null);

    setPagination((prev) => ({ ...prev, current_page: 1 }));
    setFilterResetKey((prev) => prev + 1);
  };

  const fetchDistricts = async () => {
    try {
      const response = await fetchData(
        "districts",
        "GET",
        null,
        {},
        {},
        navigate,
        "/districts",
        dispatch
      );
      setDistricts(response?.data || []);
    } catch (error) {
      console.error("Error fetching districts:", error);
    }
  };

  const fetchTehsils = async () => {
    if (!tempDistrict) return;
    try {
      const response = await fetchData(
        "tehsils",
        "GET",
        null,
        {},
        { district_id: tempDistrict },
        navigate,
        "/tehsils",
        dispatch
      );
      setTehsils(response?.data || []);
    } catch (error) {
      console.error("Error fetching tehsils:", error);
    }
  };

  const fetchUcs = async () => {
    if (!tempTehsil) return;
    try {
      const response = await fetchData(
        "ucs",
        "GET",
        null,
        {},
        { tehsil_id: tempTehsil },
        navigate,
        "/ucs",
        dispatch
      );
      setUcs(response?.data || []);
    } catch (error) {
      console.error("Error fetching UCs:", error);
    }
  };

  const fetchDehs = async () => {
    if (!tempTehsil) return;
    try {
      const response = await fetchData(
        "dehs",
        "GET",
        null,
        {},
        { tehsil_id: tempTehsil },
        navigate,
        "/dehs",
        dispatch
      );
      setDehs(response?.data || []);
    } catch (error) {
      console.error("Error fetching Dehs:", error);
    }
  };

  const fetchVillages = async () => {
    if (!tempDeh) return;
    try {
      const response = await fetchData(
        "villages",
        "GET",
        null,
        {},
        { deh_id: tempDeh },
        navigate,
        "/villages",
        dispatch
      );
      setVillages(response?.data || []);
    } catch (error) {
      console.error("Error fetching Villages:", error);
    }
  };

  const fetchHealthFacilities = async () => {
    try {
      const response = await fetchData(
        "health-fetch",
        "GET",
        null,
        {},
        {
          page: pagination.current_page,
          limit: pagination.per_page,
          search: search || undefined,
          district_id: selectedDistrict || undefined,
          tehsil_id: selectedTehsil || undefined,
          uc_id: selectedUc || undefined,
          deh_id: selectedDeh || undefined,
          village_id: selectedVillages || undefined,
          dqa_status: selectedDqaStatus || undefined,
          // verified_from_dqa: selectedDqaStatus || undefined,
          date_field: selectedDateField || undefined,
          condition: selectedCondition || undefined,
          date_value: selectedDateValue || undefined,
          start_date: selectedStartDate || undefined,
          end_date: selectedEndDate || undefined,
        },
        navigate,
        "/health-fetch",
        dispatch
      );

      const sortedData = (response?.data?.healthFacilityData || []).sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      setHealthFacilitiesData(sortedData);
      setPagination(response?.data?.pagination || {});
    } catch (error) {
      console.error("Error fetching health facilities:", error);
      if (error?.message === "No health facilities found") {
        setHealthFacilitiesData([]);
        setPagination({
          current_page: 1,
          per_page: pagination.per_page,
          total_records: 0,
          total_pages: 0,
        });
        toast.info("No health facilities found with current filters.");
      } else {
        toast.error("Failed to fetch health facilities.");
      }
    }
  };

  const fetchAllHealthFacilitiesForExport = async () => {
    try {
      const response = await fetchData(
        "health-fetch",
        "GET",
        null,
        {},
        {
          page: 1,
          limit: 10000,
          search: search || undefined,
          district_id: selectedDistrict || undefined,
          tehsil_id: selectedTehsil || undefined,
          uc_id: selectedUc || undefined,
          deh_id: selectedDeh || undefined,
          village_id: selectedVillages || undefined,
          dqa_status: selectedDqaStatus || undefined,
          date_field: selectedDateField || undefined,
          condition: selectedCondition || undefined,
          date_value: selectedDateValue || undefined,
          start_date: selectedStartDate || undefined,
          end_date: selectedEndDate || undefined,
        },
        navigate,
        "/health-fetch",
        dispatch
      );

      return response?.data?.healthFacilityData || [];
    } catch (error) {
      console.error("Error fetching all health facilities:", error);
      return [];
    }
  };

  const fetchDetailedHealthFacility = async (id) => {
    try {
      const response = await fetchData(
        `health-fetchById/${id}`,
        "GET",
        null,
        {},
        {},
        navigate,
        "/health-fetchById",
        dispatch
      );
      return response?.data;
    } catch (error) {
      console.error(
        `Error fetching detailed data for health facility ${id}:`,
        error
      );
      return null;
    }
  };

  const handleApprove = async () => {
    setApproveModalVisible(false);
    try {
      const response = await fetchData(
        `health-facility-approve/${selectedApproveId}`,
        "PUT",
        {},
        {},
        {},
        navigate,
        "/health-facility",
        dispatch
      );

      if (!response?.success) {
        throw new Error(
          response?.message || "Failed to approve the health facility."
        );
      }

      toast.success("Health facility approved successfully.");

      setHealthFacilitiesData((prev) =>
        prev.map((item) =>
          item.health_facility_id === selectedApproveId
            ? {
                ...item,
                verified_from_dqa: 1,
                verified_from_dqa_datetime: new Date().toISOString(),
                auditLogs: [
                  {
                    action: "APPROVE",
                    newvalue: JSON.stringify({
                      verified_from_dqa: 1,
                      verified_from_dqa_datetime: new Date().toISOString(),
                    }),
                    createdAt: new Date().toISOString(),
                    user: {
                      name: loggedInUser?.userData?.name || "Super Admin",
                    },
                  },
                  ...(item.auditLogs || []),
                ],
              }
            : item
        )
      );
    } catch (error) {
      console.error("Error approving health facility:", error);
      toast.error(
        error?.message ||
          "An error occurred while approving the health facility."
      );
    }
  };

  const handleReject = async () => {
    setRejectModalVisible(false);
    setRemarksModalVisible(true);
  };
  const handleSubmitRemarks = async () => {
    const validationError = validateRemarks(remarks);

    if (validationError) {
      setRemarksError(validationError);
      return;
    }

    try {
      const response = await fetchData(
        `health-facility-reject/${selectedRejectId}`,
        "PUT",
        { verified_from_dqa_status: 2, remarks: remarks.trim() },
        {},
        {},
        navigate,
        "/health-facility",
        dispatch
      );

      if (!response?.success) {
        throw new Error(
          response?.message || "Failed to reject the health facility."
        );
      }

      toast.success("Health facility rejected successfully.");
      const updatedData = healthFacilitiesData.map((item) =>
        item.health_facility_id === selectedRejectId
          ? {
              ...item,
              verified_from_dqa: 2,
              verified_from_dqa_datetime:
                response.data?.verified_from_dqa_datetime ||
                new Date().toISOString(),
              remarks: remarks.trim(),
              auditLogs: [
                {
                  action: "REJECT",
                  newvalue: JSON.stringify({
                    verified_from_dqa_status: 2,
                    remarks: remarks.trim(),
                  }),
                  createdAt: new Date().toISOString(),
                  user: {
                    name: loggedInUser?.userData?.name || "Super Admin",
                  },
                },
                ...(item.auditLogs || []),
              ],
            }
          : item
      );

      setHealthFacilitiesData(updatedData);
      const updatedFacility = updatedData.find(
        (item) => item.health_facility_id === selectedRejectId
      );
      setRemarksModalVisible(false);
      setSelectedHealthFacilityForRemarks(updatedFacility);
      setViewRemarksModalVisible(false);
      setRemarks("");
      setRemarksError("");
    } catch (error) {
      console.error("Error rejecting health facility:", error);
      toast.error(
        error?.message ||
          "An error occurred while rejecting the health facility."
      );
    }
  };

  const handleCancelRemarks = () => {
    setRemarksModalVisible(false);
    setRemarks("");
    setRemarksError("");
  };

  const showApproveModal = (id) => {
    setSelectedApproveId(id);
    setApproveModalVisible(true);
  };

  const showRejectModal = (id) => {
    setSelectedRejectId(id);
    setRejectModalVisible(true);
  };

  const formatApprovalDateTime = (dateTimeString) => {
    if (!dateTimeString) return null;

    const date = new Date(dateTimeString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDateTimeForDisplay = (dateTimeString) => {
    if (!dateTimeString) return "N/A";

    const date = new Date(dateTimeString);
    if (isNaN(date)) return "N/A";

    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDateForExport = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "N/A";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const toYesNo = (value) => {
    if (value === 1 || value === true || value === "1" || value === "true") {
      return "Yes";
    } else if (
      value === 0 ||
      value === false ||
      value === "0" ||
      value === "false"
    ) {
      return "No";
    }
    return "N/A";
  };

  const getDQAStatus = (status) => {
    if (status === 1) return "Approved";
    if (status === 2) return "Rejected";
    return "Pending";
  };

  const handleExport = async () => {
    if (healthFacilitiesData.length === 0) {
      toast.warning("No health facilities data available to export.");
      return;
    }

    setIsExporting(true);

    try {
      const allHealthFacilities = await fetchAllHealthFacilitiesForExport();

      if (allHealthFacilities.length === 0) {
        toast.warning("No health facilities found with current filters.");
        setIsExporting(false);
        return;
      }

      const healthIds = allHealthFacilities.map((f) => f.health_facility_id);
      const detailedHealthFacilities = await Promise.all(
        healthIds.map((id) => fetchDetailedHealthFacility(id))
      ).then((results) => results.filter(Boolean));

      const workbook = XLSX.utils.book_new();

      const locationKeys = ["District", "Tehsil", "UC", "Deh", "Village"];

      const facilityKeysWithoutLocations = [
        "Health Facility ID",
        "Name of Health Facility",
        "Incharge Name",
        "Incharge Contact",
        "Facility Contact",
        "Date of Data Collection",
        "Health Facility Type",
        "Health Facility Type Other",
        "Health Status",
        "Pharmacy Available",
        "Health Ownership",
        "Health Ownership Others",
        "Health Functional",
        "Number of Doctors",
        "Number of LHVs",
        "Number of Dispensers",
        "Number of Vaccinators",
        "Total Health Staff",
        "Health Staff Other",
        "Verified from DQA",
        "Verified from DQA Datetime",
        "Remarks",
        "Latitude",
        "Longitude",
        "Status",
      ];
      const infrastructureKeys = [
        "Building Condition",
        "Boundary Wall",
        "Boundary Repair Needed",
        "Boundary Repair Cost",
        "Health Building Structure",
        "Total Number of Rooms",
        "Number of Consulting Rooms",
        "Number of Wards Rooms",
        "Number of Delivery Rooms",
        "Number of Beds",
        "Power Supply",
        "Water Storage Type",
        "Specify Other Storage",
        "Year Round Water Availability",
        "Handwash Stations Status",
        "Water Source",
        "Functional Latrines Total",
        "Functional Latrines Male",
        "Functional Latrines Female",
        "Functional Latrines Repair",
        "Functional Repair Cost",
        "Non Functional Latrines Total",
        "Non Functional Latrines Male",
        "Non Functional Latrines Female",
        "Non Functional Latrines Repair",
        "Non Functional Repair Cost",
        "Handwashing Stations Available",
        "Handwashing Stations Count",
        "Handwashing Repairable",
        "Handwashing Repair Cost",
      ];
      const servicesKeys = [
        "Outpatient Services",
        "Maternal Services",
        "Child Services",
        "Laboratory Services",
        "Family Planning Services",
        "Emergency Care",
        "Referral System",
        "Issues Faced by Patients",
        "Suggestions for Improvement",
      ];

      const allHeaders = [
        ...locationKeys,
        ...facilityKeysWithoutLocations,
        ...infrastructureKeys,
        ...servicesKeys,
      ];

      const allRows = detailedHealthFacilities.map((data) => {
        const facility = data.healthFacility || {};
        const infrastructure = data.healthInfrastructure || {};
        const services = data.healthServices || {};

        const row = {};

        locationKeys.forEach((key) => {
          row[key] = "N/A";
        });

        facilityKeysWithoutLocations.forEach((key) => {
          const field = key
            .toLowerCase()
            .replace(/\s+/g, "_")
            .replace(/[^a-z0-9_]/g, "");
          let value = facility[field];
          if (key === "Date of Data Collection") {
            value = formatDateForExport(value);
          } else if (
            key === "Pharmacy Available" ||
            key === "Health Functional"
          ) {
            value = toYesNo(value);
          } else if (key === "Verified from DQA") {
            value = getDQAStatus(value);
          } else if (key === "Status") {
            value = value ? "Active" : "Inactive";
          } else if (key === "Verified from DQA Datetime") {
            value = formatApprovalDateTime(value);
          } else if (key === "Remarks") {
            value = facility.remarks || "N/A";
          }
          row[key] = value || "N/A";
        });
        infrastructureKeys.forEach((key) => {
          const field = key
            .toLowerCase()
            .replace(/\s+/g, "_")
            .replace(/[^a-z0-9_]/g, "");
          let value = infrastructure[field];
          if (typeof value === "boolean") {
            value = toYesNo(value);
          }
          row[key] = value || "N/A";
        });
        servicesKeys.forEach((key) => {
          const field = key
            .toLowerCase()
            .replace(/\s+/g, "_")
            .replace(/[^a-z0-9_]/g, "");
          let value = services[field];
          if (typeof value === "boolean") {
            value = toYesNo(value);
          }
          row[key] = value || "N/A";
        });
        row["District"] = facility.district_name || "N/A";
        row["Tehsil"] = facility.tehsil_name || "N/A";
        row["UC"] = facility.uc_name || "N/A";
        row["Deh"] = facility.deh_name || "N/A";
        row["Village"] = facility.village_name || "N/A";

        return row;
      });
      const headers = allHeaders;
      const data = allRows.map((row) =>
        headers.map((header) => row[header] ?? "")
      );
      const aoa = [headers, ...data];

      const ws = XLSX.utils.aoa_to_sheet(aoa);
      for (let colNum = 0; colNum < headers.length; colNum++) {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colNum });
        if (!ws[cellAddress]) continue;
        if (!ws[cellAddress].s) ws[cellAddress].s = {};
        ws[cellAddress].s.font = { size: 10, bold: true };
        ws[cellAddress].s.alignment = {
          horizontal: "center",
          vertical: "center",
        };
      }
      for (let rowNum = 1; rowNum <= data.length; rowNum++) {
        for (let colNum = 0; colNum < headers.length; colNum++) {
          const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
          if (!ws[cellAddress]) continue;

          if (!ws[cellAddress].s) ws[cellAddress].s = {};

          ws[cellAddress].s.font = { size: 9 };

          ws[cellAddress].s.alignment = {
            horizontal: "left",
            wrapText: true,
            vertical: "center",
          };

          ws[cellAddress].t = "s";
        }
      }

      ws["!cols"] = headers.map(() => ({ wch: 15 }));

      XLSX.utils.book_append_sheet(workbook, ws, "Health Facilities Detailed");

      // Filename
      let filename = "health_facility_detailed_export";
      if (selectedDistrict) {
        const districtName =
          districts.find((d) => d.district_id === selectedDistrict)
            ?.district_name || selectedDistrict;
        filename += `_${districtName}`;
      }
      if (selectedTehsil) {
        const tehsilName =
          tehsils.find((t) => t.tehsil_id === selectedTehsil)?.tehsil_name ||
          selectedTehsil;
        filename += `_${tehsilName}`;
      }
      if (selectedVillages) {
        const villageName =
          villages.find((v) => v.village_id === selectedVillages)
            ?.village_name || selectedVillages;
        filename += `_${villageName}`;
      }
      const currentDate = new Date().toISOString().split("T")[0];
      filename += `_${currentDate}.xlsx`;

      XLSX.writeFile(workbook, filename);

      toast.success(`Export completed successfully! File: ${filename}`);
    } catch (error) {
      console.error("Error during export:", error);
      toast.error("Failed to export data. Please try again.");
    } finally {
      setIsExporting(false);
    }
  };

  useEffect(() => {
    fetchDistricts();
  }, []);

  useEffect(() => {
    fetchTehsils();
  }, [tempDistrict]);

  useEffect(() => {
    fetchUcs();
  }, [tempTehsil]);

  useEffect(() => {
    fetchDehs();
  }, [tempTehsil]);

  useEffect(() => {
    fetchVillages();
  }, [tempDeh]);

  useEffect(() => {
    fetchHealthFacilities();
  }, [
    pagination.current_page,
    pagination.per_page,
    selectedDistrict,
    selectedTehsil,
    selectedUc,
    selectedDeh,
    selectedVillages,
    selectedDqaStatus,
    selectedDateField,
    selectedCondition,
    selectedDateValue,
    selectedStartDate,
    selectedEndDate,
  ]);

  const handlePageSizeChange = (size) => {
    setPagination((prev) => ({ ...prev, per_page: size, current_page: 1 }));
  };

  const handlePageChange = (event, value) => {
    setPagination((prev) => ({ ...prev, current_page: value }));
  };

  useEffect(() => {
    const delayedSearch = setTimeout(() => {
      if (search !== undefined) {
        if (pagination.current_page !== 1) {
          setPagination((prev) => ({ ...prev, current_page: 1 }));
        } else {
          fetchHealthFacilities();
        }
      }
    }, 500);

    return () => clearTimeout(delayedSearch);
  }, [search]);

  const handleDelete = async () => {
    setModalVisible(false);

    setHealthFacilitiesData((prev) =>
      prev.filter((facility) => facility.health_facility_id !== selectedUuid)
    );

    try {
      const response = await fetchData(
        `health-facility-delete/${selectedUuid}`,
        "DELETE",
        {},
        {},
        {},
        navigate,
        "/health-facility",
        dispatch
      );

      if (!response?.success) {
        throw new Error(
          response?.message || "Failed to delete the health facility."
        );
      }

      toast.success("Health facility deleted successfully.");
    } catch (error) {
      console.error("Error deleting health facility:", error);
      toast.error(
        error?.message ||
          "An error occurred while deleting the health facility."
      );

      fetchHealthFacilities();
    }
  };

  const showDeleteModal = (id) => {
    setSelectedUuid(id);
    setModalVisible(true);
  };

  const toggleStatus = async (facilityId, currentStatus) => {
    try {
      setHealthFacilitiesData((prev) =>
        prev.map((facility) =>
          facility.health_facility_id === facilityId
            ? { ...facility, status: currentStatus ? 0 : 1 }
            : facility
        )
      );

      const response = await fetchData(
        `healthfacility-status/${facilityId}`,
        "PUT",
        { status: currentStatus ? 0 : 1 },
        {},
        {},
        navigate,
        "/health-facility",
        dispatch
      );

      if (!response?.success) {
        throw new Error(response?.message || "Failed to update status.");
      }

      toast.success("Status updated successfully.");
    } catch (error) {
      console.error("Status update error:", error);
      toast.error(error?.message || "An error occurred while updating status.");
      fetchHealthFacilities();
    }
  };

  const columns = [
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          Health Facility Name
        </span>
      ),
      selector: (row) => row.name_of_health_facility || "N/A",
      sortable: true,
    },
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          Incharge Name
        </span>
      ),
      selector: (row) => row.incharge_name || "N/A",
      sortable: true,
    },
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          Facility Type
        </span>
      ),
      selector: (row) => row.health_facility_type || "N/A",
      sortable: true,
    },
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          Ownership
        </span>
      ),
      selector: (row) => row.health_ownership || "N/A",
      sortable: true,
    },
    {
      name: (
        <span className="text-[0.9rem] text-[#212529] uppercase">
          DQA Approval
        </span>
      ),
      cell: (row) => {
        const isApproved =
          row.verified_from_dqa === 1 || row.verified_from_dqa === "1";
        const isRejected =
          row.verified_from_dqa === 2 || row.verified_from_dqa === "2";
        const approvalDateTime = formatApprovalDateTime(
          row.verified_from_dqa_datetime
        );
        const rejectionDateTime = formatApprovalDateTime(
          row.verified_from_dqa_datetime
        );

        return (
          <div className="text-center">
            {isApproved ? (
              <>
                <span className="py-1 px-2 text-[0.75rem] rounded-full font-semibold bg-blue-100 text-blue-800">
                  Approved
                </span>
                {approvalDateTime && (
                  <div className="text-[0.65rem] text-gray-600 mt-2">
                    {approvalDateTime}
                  </div>
                )}
              </>
            ) : isRejected ? (
              <>
                <span className="py-1 px-2 text-[0.75rem] rounded-full font-semibold bg-red-100 text-red-800">
                  Rejected
                </span>
                {rejectionDateTime && (
                  <div className="text-[0.65rem] text-gray-600 mt-2">
                    {rejectionDateTime}
                  </div>
                )}
              </>
            ) : (
              <span className="py-1 px-2 text-[0.75rem] rounded-full font-semibold bg-yellow-100 text-yellow-800 ml-6">
                Pending
              </span>
            )}
          </div>
        );
      },
    },
  ];

  {
    if (
      permissions.includes("health-facility-assessment-update") ||
      permissions.includes("health-facility-assessment-delete") ||
      permissions.includes("health-facility-assessment-approve") ||
      permissions.includes("health-facility-assessment-reject")
    ) {
      columns.push({
        name: (
          <span className="text-[0.9rem] text-[#212529] uppercase">Action</span>
        ),
        cell: (row) => {
          const isApproved =
            row.verified_from_dqa === 1 || row.verified_from_dqa === "1";
          const isRejected =
            row.verified_from_dqa === 2 || row.verified_from_dqa === "2";
          const hasRemarks = getLatestRemarks(row) !== "No remarks";

          return (
            <div className="flex gap-2">
              {/* View Remarks Button - Show if has remarks OR is rejected (because rejected should have remarks) */}
              {(hasRemarks || isRejected) && (
                <button
                  onClick={() => showRemarksDialog(row)}
                  title="View Remarks"
                  className="text-blue-600 hover:text-blue-800 hover:scale-110 transition-transform"
                >
                  <i className="fa-solid fa-comment fa-lg"></i>
                </button>
              )}
              <PermissionButton
                hasPermission={permissions.includes(
                  "health-facility-assessment-update"
                )}
                to={`/healthfacilityassessment/edit/${row.health_facility_id}`}
                faIcon={
                  isApproved || isRejected
                    ? "fa-solid fa-eye fa-lg"
                    : "fa-solid fa-pen-to-square fa-lg"
                }
                onlyIcon={true}
                enabledClass=""
                disabledClass="opacity-50 cursor-not-allowed"
              />
              {permissions.includes("health-facility-assessment-approve") &&
                !isApproved &&
                !isRejected && (
                  <button
                    onClick={() => showApproveModal(row.health_facility_id)}
                    title="Approve"
                    className="hover:scale-110 transition-transform"
                  >
                    <i className="fa-solid fa-check-circle fa-lg text-green-600 hover:text-green-800"></i>
                  </button>
                )}
              {permissions.includes("health-facility-assessment-reject") &&
                !isApproved &&
                !isRejected && (
                  <button
                    onClick={() => showRejectModal(row.health_facility_id)}
                    title="Reject"
                    className="hover:scale-110 transition-transform"
                  >
                    <i className="fa-solid fa-times-circle fa-lg text-red-600 hover:text-red-800"></i>
                  </button>
                )}
              {permissions.includes("health-facility-assessment-delete") &&
                !isApproved && (
                  <PermissionButton
                    hasPermission={permissions.includes(
                      "health-facility-assessment-delete"
                    )}
                    faIcon="fa fa-trash fa-lg text-primaryDark"
                    onlyIcon
                    onClick={() => showDeleteModal(row.health_facility_id)}
                    className="p-1 rounded-full bg-gray-200 text-[#137e81] hover:text-white"
                    enabledClass=""
                    disabledClass="opacity-50 cursor-not-allowed bg-gray-300"
                  />
                )}
            </div>
          );
        },
      });
    }
  }

  const customStyles = {
    headCells: {
      style: {
        border: "1px solid #f3f3f3",
        backgroundColor: "#fff",
        color: "black",
        fontWeight: "bold",
        fontSize: "1.075rem",
        textAlign: "center",
      },
    },
    cells: {
      style: {
        border: "1px solid #f3f3f3",
        textAlign: "center",
      },
    },
  };

  return (
    <div>
      <div className="my-4 flex justify-between items-center">
        <h1 className="text-[1.475rem] text-[#212529] font-[Bold]">
          Health Facility Assessment
        </h1>

        {hasDataToExport && (
          <button
            onClick={handleExport}
            disabled={isExporting}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold transition-all ${
              isExporting
                ? "bg-gray-400 text-gray-700 cursor-not-allowed"
                : "bg-[#137e81] text-white hover:bg-[#0f6c6f] hover:scale-105"
            }`}
            title="Export filtered data to Excel"
          >
            <Download size={18} />
            {isExporting ? "Exporting..." : "Export Excel"}
          </button>
        )}
      </div>

      <Accordion expanded={isFiltersVisible}>
        <AccordionSummary
          expandIcon={
            isFiltersVisible ? (
              <Minus color="#ffff" size={14} />
            ) : (
              <Plus size={14} color="#ffff" />
            )
          }
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{
            backgroundColor: "#137e81",
            color: "#fff !important",
            "& .MuiAccordionSummary-content": {
              color: "#fff  !important",
            },
          }}
          onClick={toggleFilters}
        >
          Filters
        </AccordionSummary>

        <AccordionDetails>
          <div className="space-y-4">
            {/* ===================== FIRST ROW (4 DROPDOWNS) ===================== */}
            <div key={filterResetKey}>
              <div className="grid grid-cols-4 gap-5 w-full">
                <ThinDropdownWithSearch required={false}
                  label="District"
                  id="district-dropdown"
                  options={districts?.map((dis) => ({
                    value: dis?.district_id,
                    label: dis?.district_name,
                  }))}
                  value={tempDistrict}
                  onChange={handleDistrictChange}
                />

                <ThinDropdownWithSearch required={false}
                  label="Tehsil"
                  id="tehsil-dropdown"
                  options={tehsils?.map((tehsil) => ({
                    value: tehsil?.tehsil_id,
                    label: tehsil?.tehsil_name,
                  }))}
                  value={tempTehsil}
                  onChange={handleTehsilChange}
                />

                <ThinDropdownWithSearch required={false}
                  label="Deh"
                  id="deh-dropdown"
                  options={dehs?.map((deh) => ({
                    value: deh?.deh_id,
                    label: deh?.deh_name,
                  }))}
                  value={tempDeh}
                  onChange={handleDehChange}
                />

                <ThinDropdownWithSearch required={false}
                  label="Village"
                  id="village-dropdown"
                  options={villages?.map((v) => ({
                    value: v?.village_id,
                    label: v?.village_name,
                  }))}
                  value={tempVillage}
                  onChange={handleVillageChange}
                />
              </div>
            </div>

            {/* ===================== SECOND ROW ===================== */}
            <div className="grid grid-cols-4 gap-5 w-full">
              <ThinDropdownWithSearch required={false}
                label="DQA Status"
                id="dqa-status-dropdown"
                options={dqaStatusOptions}
                value={tempDqaStatus}
                onChange={handleDqaStatusChange}
              />

              <ThinDropdownWithSearch required={false}
                label="Date Field"
                id="date-field-dropdown"
                options={dateFieldsOptions}
                value={tempDateField}
                onChange={(value) => handleFilterChange("dateField", value)}
              />

              <ThinDropdownWithSearch required={false}
                label="Condition"
                id="condition-dropdown"
                options={conditions}
                value={tempCondition}
                onChange={(value) => handleFilterChange("condition", value)}
                disabled={!tempDateField}
              />

              {tempCondition !== "between" && (
                <ThinTextField isRequired={false}
                  label="Date Value"
                  type="date"
                  value={tempDateValue}
                  onChange={(e) => setTempDateValue(e.target.value)}
                  disabled={!tempCondition}
                  inputProps={{
                    max: new Date().toISOString().split("T")[0],
                  }}
                />
              )}
            </div>

            {/* ===================== BETWEEN DATES ===================== */}
            {tempCondition === "between" && (
              <div className="grid grid-cols-4 gap-5 w-full">
                <ThinTextField isRequired={false}
                  label="Start Date"
                  type="date"
                  value={tempStartDate}
                  onChange={(e) => setTempStartDate(e.target.value)}
                  inputProps={{
                    max: new Date().toISOString().split("T")[0],
                  }}
                />

                <ThinTextField isRequired={false}
                  label="End Date"
                  type="date"
                  value={tempEndDate}
                  onChange={(e) => setTempEndDate(e.target.value)}
                  inputProps={{
                    max: new Date().toISOString().split("T")[0],
                    min: tempStartDate || undefined,
                  }}
                />

                <div />
                <div />
              </div>
            )}
          </div>

          {/* ===================== ACTION BUTTONS ===================== */}
          <div className="flex gap-2 mt-4 justify-end">
            <button
              onClick={handleClearFilters}
              className="px-4 py-2 bg-[#be9609] text-white rounded-lg hover:bg-[#a68108] transition-colors"
            >
              Clear
            </button>

            <button
              onClick={handleApplyFilters}
              className="px-4 py-2 bg-[#137e81] text-white rounded-lg transition-colors"
            >
              Apply
            </button>
          </div>
        </AccordionDetails>
      </Accordion>

      <div className="rounded-lg my-[15px] shadow w-full bg-white">
        <div className="p-4 flex md:flex-row rounded-t-lg gradiant2 flex-col gap-3 justify-between md:items-center border-lightGray border-b ">
          <h1 className="text-[0.875rem] tracking-[0.0625rem] text-[#856800] font-[bold] uppercase">
            Manage Health Facility Assessment
          </h1>

          {hasFiltersApplied && (
            <div className="text-sm text-gray-600">
              {pagination.total_records} records found
              {hasDataToExport && (
                <span className="ml-2 text-green-600 font-medium">
                  • Export available
                </span>
              )}
              {selectedDqaStatus && (
                <span className="ml-2 text-blue-600 font-medium">
                  • DQA Status:{" "}
                  {dqaStatusOptions.find(
                    (opt) => opt.value === selectedDqaStatus
                  )?.label || selectedDqaStatus}
                </span>
              )}
            </div>
          )}
        </div>
        <div className="p-[1.25rem] w-full">
          <div className="flex lg:flex-row flex-col lg:justify-between justify-start gap-2 lg:items-center items-start mb-[6px] w-full">
            <PaginationDropdown
              value={pagination.per_page}
              onChange={handlePageSizeChange}
              options={[
                { value: 10, label: "10" },
                { value: 20, label: "20" },
                { value: 30, label: "30" },
              ]}
            />

            <input
              onChange={(e) => setSearch(e.target.value)}
              value={search}
              placeholder="Search..."
              type="search"
              className="font-[Light] text-[14px] flex items-center bg-[#f1f4f8] border-[#ebeef2] border-[1px] rounded-md px-3 py-1 outline-none"
            />
          </div>
          <DataTable
            columns={columns}
            data={healthFacilitiesData}
            persistTableHead
            customStyles={customStyles}
            highlightOnHover
            progressPending={false}
          />
          <GeneralFooter
            pagination={pagination}
            handlePageChange={handlePageChange}
            handlePageSizeChange={handlePageSizeChange}
            dataLength={healthFacilitiesData.length}
          />
        </div>
      </div>

      <CustomConfirmModal
        isVisible={isModalVisible}
        onConfirm={handleDelete}
        onCancel={() => setModalVisible(false)}
        message="Are you sure you want to delete this Health Facility?"
      />

      <CustomConfirmModal
        isVisible={isApproveModalVisible}
        onConfirm={handleApprove}
        onCancel={() => setApproveModalVisible(false)}
        message="Are you sure you want to approve this Health Facility from DQA?"
      />

      <CustomConfirmModal
        isVisible={isRejectModalVisible}
        onConfirm={handleReject}
        onCancel={() => setRejectModalVisible(false)}
        message="Are you sure you want to reject this Health Facility from DQA?"
      />

      {/* View Remarks Dialog */}
      <Dialog
        open={isViewRemarksModalVisible}
        onClose={closeRemarksDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "8px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
            maxWidth: "600px",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#137e81",
            color: "white",
            padding: "16px 24px",
            fontSize: "1.25rem",
            fontWeight: "bold",
          }}
        >
          Remarks History
          {selectedHealthFacilityForRemarks && (
            <Typography
              variant="subtitle1"
              sx={{ color: "white", fontSize: "0.9rem", mt: 1 }}
            >
              Health Facility ID:{" "}
              {selectedHealthFacilityForRemarks.health_facility_id} -{" "}
              {selectedHealthFacilityForRemarks.name_of_health_facility}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent sx={{ padding: "24px", maxHeight: "60vh" }}>
          {selectedHealthFacilityForRemarks && (
            <Box>
              <Typography variant="h6" sx={{ mb: 2, color: "#137e81" }}>
                {/* Remarks History */}
              </Typography>

              {(() => {
                const history = getRemarksHistory(
                  selectedHealthFacilityForRemarks
                );

                return history.length > 0 ? (
                  <Box sx={{ maxHeight: "300px", overflowY: "auto" }}>
                    {history.map((historyItem, index) => (
                      <Box
                        key={index}
                        sx={{
                          mb: 2,
                          p: 2,
                          border: "1px solid #e0e0e0",
                          borderRadius: "4px",
                          backgroundColor: index === 0 ? "#f0f8ff" : "white",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            mb: 1,
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: "bold", color: "#333" }}
                          >
                            {/* {historyItem.action} */}
                          </Typography>
                          <Typography variant="caption" sx={{ color: "#666" }}>
                            {formatDateTimeForDisplay(historyItem.date)}
                          </Typography>
                        </Box>

                        <Box sx={{ mt: 1 }}>
                          
                          <Typography variant="body2">
                            <strong>Remarks :</strong>{" "}
                            <span
                              style={{ color: "#2e7d32", fontWeight: "bold" }}
                            >
                              {historyItem.to}
                            </span>
                          </Typography>
                        </Box>

                        <Typography
                          variant="caption"
                          sx={{ color: "#666", mt: 1, display: "block" }}
                        >
                          User Name : {historyItem.userName}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                ) : (
                  <Typography
                    variant="body1"
                    sx={{ textAlign: "center", color: "#666", py: 3 }}
                  >
                    No remarks history available
                  </Typography>
                );
              })()}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px" }}>
          <Button
            onClick={closeRemarksDialog}
            color="primary"
            variant="contained"
            sx={{
              backgroundColor: "#137e81",
              "&:hover": {
                backgroundColor: "#0f6c6f",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Rejection Remarks Modal */}
      <Dialog
        open={isRemarksModalVisible}
        onClose={handleCancelRemarks}
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: "8px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#137e81",
            color: "white",
            padding: "16px 24px",
            fontSize: "1.25rem",
            fontWeight: "bold",
          }}
        >
          Rejection Remarks
        </DialogTitle>
        <DialogContent sx={{ padding: "24px" }}>
          <Box sx={{ marginBottom: "16px" }}>
            <Typography
              variant="body1"
              sx={{
                marginBottom: "8px",
                color: "#333",
                fontWeight: "500",
              }}
            >
              Please provide the reason for rejection:
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: "#666",
                fontStyle: "italic",
              }}
            >
              Remarks must be between 10 and 255 characters.
            </Typography>
          </Box>
          <TextField
            autoFocus
            label="Remarks"
            type="text"
            fullWidth
            multiline
            rows={4}
            value={remarks}
            onChange={handleRemarksChange}
            placeholder="Enter detailed reason for rejection (minimum 10 characters, maximum 255 characters)..."
            variant="outlined"
            error={!!remarksError}
            helperText={
              remarksError ||
              `${remarks.trim().length}/255 characters` +
                (remarks.trim().length > 0
                  ? ` (${
                      remarks.trim().length < 10
                        ? `${10 - remarks.trim().length} more required`
                        : "valid length"
                    })`
                  : "")
            }
            sx={{
              "& .MuiOutlinedInput-root": {
                "&:hover fieldset": {
                  borderColor: "#137e81",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#137e81",
                },
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "#137e81",
              },
              "& .MuiFormHelperText-root": {
                color: remarksError ? "#d32f2f" : "#666",
              },
            }}
          />
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px", gap: "8px" }}>
          <Button
            onClick={handleCancelRemarks}
            color="secondary"
            variant="outlined"
            sx={{
              borderColor: "#6c757d",
              color: "#6c757d",
              "&:hover": {
                borderColor: "#545b62",
                backgroundColor: "rgba(108, 117, 125, 0.04)",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmitRemarks}
            color="primary"
            variant="contained"
            disabled={
              !remarks.trim() ||
              remarks.trim().length < 10 ||
              remarks.trim().length > 255
            }
            sx={{
              backgroundColor: "#137e81",
              "&:hover": {
                backgroundColor: "#0f6c6f",
              },
              "&:disabled": {
                backgroundColor: "#cccccc",
                color: "#666666",
              },
            }}
          >
            Submit Rejection
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default HealthFacilityAssessmentsListing;
